import React, { useRef, useState, useEffect } from 'react';
import paper from 'paper';
import ProgressBar from '../ProgressBar';

const Snake = ({
  strokeColor = 'blue',
  strokeWidth = 20,
  increment = 0.1,
  gap = 10,
  fillColor = 'black',
  barColor = 'rgba(0,0,0,0.45)',
  documentBackgroundColor = 'white',
  texts = [
    {
      text: 'Sample 1',
      count: 100,
      fontSize: 50,
    },
    {
      text: 'An then 2',
      count: 200,
      fontSize: 100,
    },
    {
      text: 'Finally 3',
      count: 300,
      fontSize: 300,
    }
  ],
  content = {
    justification: 'center',
    fontSize: texts[0].fontSize + 'px',
  },
  strokeCap = false,
}) => {

  const canvasRef = useRef(null);
  const strokeCounter = useRef(20);
  const barRef = useRef({ index: 0, counter: 0 });
  const [barProgress, setBarProgress] = useState({ index: 0, counter: 0 });

  useEffect(() => {
    paper.setup(canvasRef.current);

    const curveTrail = new paper.Path();
    curveTrail.strokeColor = strokeColor;
    curveTrail.strokeWidth = strokeWidth;
    curveTrail.strokeJoin = 'round';
    if (strokeCap) curveTrail.strokeCap = 'round';

    const displayText = new paper.PointText({
      point: [paper.view.size.width/2, paper.view.size.height/2],
      content: texts[0].text,
      ...content,
    });
    displayText.fillColor = fillColor;

    const onMouseMove = (event) => {
      document.body.style.backgroundColor = documentBackgroundColor;
      const mousePoint = event.point;

      strokeCounter.current += increment;
      curveTrail.add(new paper.Point(mousePoint.x, mousePoint.y));
      curveTrail.dashArray = [strokeCounter.current, gap];

      displayText.point = mousePoint;
      displayText.rotation = mousePoint.x;

      const bar = barRef.current;
      if (bar.index < texts.length - 1) bar.counter += 1;
      if (bar.counter > texts[bar.index].count) {
        bar.index += 1;
        displayText.content = texts[bar.index].text;
        displayText.fontSize = texts[bar.index].fontSize;
      }
      setBarProgress({ index: bar.index, counter: bar.counter });
    };

    paper.view.on('mousemove', onMouseMove);

    return () => {
      paper.view.off('mousemove', onMouseMove);
      paper.project.clear();
    };
  }, []);

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <canvas ref={canvasRef} style={{ width: '100%', height: '100%' }} />
      <ProgressBar
        texts={texts}
        index={barProgress.index}
        counter={barProgress.counter}
        color={barColor}
      />
    </div>
  );
};

export default Snake;
